// import "antd/dist/antd.css";

import React, { useState, useEffect } from "react";
import { AutoComplete as AntAutoComplete } from "antd";
import styles from "../../styles/Registers.module.css";
import { diagnosesService } from "../../../services/diagnoses";
import { showApiErrors } from "../../../utils/showApiErrors";

export const AutoComplete = (props) => {
  const [options, setOptions] = useState([]);
  const [diagnoses, setDiagnoses] = useState([]);
  const [loading, setLoading] = useState(false);

  async function getDiagnoses(searchValue) {
    setLoading(true);
    try {
      const { results } = await diagnosesService.getAllDiagnoses(searchValue);
      const options = results.map((option) => {
        const obj = { ...option };
        obj["value"] =
          option["code"] +
          " – " +
          option["name"] +
          " – " +
          option["latin_name"];
        return obj;
      });
      setDiagnoses(options);
    } catch (e) {
      showApiErrors(e);
    } finally {
      setLoading(false);
    }
  }

  const onDiagnosisSelect = (value, option) => {
    let obj;
    if (props.itemAutocomplete) {
      const { name, unit, unit_price, tax, code } = option;
      obj = { name, unit, unit_price, tax, code };
    } else {
      obj = {
        diagnosis_code: props.field === "name" ? value : option.code,
        diagnosis_name: props.field !== "name" ? value : option.name,
        diagnosis_latin_name: option.latin_name,
      };
    }
  };
  return (
    <div>
      <AntAutoComplete
        name="diagnosis"
        onSelect={onDiagnosisSelect}
        options={diagnoses}
        onChange={(value) => {
          if (value.length == 2) getDiagnoses(value);
          else if (value.length < 2) setDiagnoses([]);
          props.changeValue(props.autocompleteName, value);
        }}
        value={props.autocompleteValue}
        className={!props.itemAutocomplete ? styles.diagnosisInput : ""}
        placeholder={props.placeHolder}
        autoFocus={props.focus}
        // onKeyUp={(value) => {
        //   props.field === 'name'? TODO TODO TODO
        //
        // }}
        filterOption={(inputValue, option) => {
          return (
            option.name.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1 ||
            option.code.toUpperCase().indexOf(inputValue.toUpperCase()) !==
              -1 ||
            option.latin_name
              .toUpperCase()
              .indexOf(inputValue.toUpperCase()) !== -1
          );
        }}
      />
    </div>
  );
};
